import React from "react";
import { IMenuProps } from "../MenuProps";
import { IAppConfig } from "../../sharedInterfaces";
import {
  MenuWrapper,
  MenuContainer,
  FooterContainer,
  PriceWrapper,
  TotalPrice,
  ButtonWithBackground,
  FooterDetail,
  FooterDetailText,
  FooterOpenBtn,
  NotifyWrapper,
} from "./MenuSimple-styled";

import { isMobile, isLowHeight } from "./ui-helpers";

import { Materials, Stones, Engraving, Dimensions } from "./Tabs/Tabs";

import {
  ArrowRightOutlined,
  RightOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";

interface Props {
  menuType: "ifr" | "luxe" | "simple" | "simpleLuxe";
  menuProps: IMenuProps;
  isPlugin: boolean;
  appConfig: IAppConfig;
  isSave: boolean;
  saveDesign: () => {};
  downloadSS: () => {};
  hideRef: boolean;
}

interface State {
  scrolling: boolean;
  isOpen: boolean;
  isNoti: boolean;
}

export default class MenuSimple extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      scrolling: false,
      isOpen: false,
      isNoti: false,
    };
  }
  timer = null;

  componentDidMount() {
    // console.log('currentMenuTab',this.props.currentMenuTab)
    // console.log('fingerSizeOptions',this.props.fingerSizeOptions)
    this.resize();
  }

  componentDidUpdate(prevProps, prevState): void {
    if (this.props.menuProps.configID != prevProps.configID) {
      console.log("current props", this.props.menuProps.configID);
      console.log("prev props", prevProps.configID);
    }

    if (prevProps.checkoutIssues != this.props.menuProps.checkoutIssues) {
      const mobile = isMobile();
      if (
        mobile &&
        this.props.menuProps.checkoutIssues.includes("fingerSize") &&
        !prevState.isOpen
      ) {
        this.setState({ isOpen: true });
      }
      if (
        this.props.menuProps.checkoutIssues.includes("fingerSize") &&
        !prevState.isNoti
      ) {
        this.setState({ isNoti: true });
      }
      if (this.state.isNoti === true && prevState.isNoti === false) {
        setTimeout(() => {
          this.setState({ isNoti: false });
        }, 3000);
      }
    }
  }

  resize = () => {
    if (!isMobile() && this.props.menuProps.currentMenuTab === -1) {
      this.props.menuProps.onMenuTabChange(0);
    } else {
      //We always want to call onMenuTabChange for its side effects
      this.props.menuProps.onMenuTabChange(this.props.menuProps.currentMenuTab);
    }
    // this.setState({ deviceInfo: vhCheck() });
  };

  render() {
    const {
      currentMenuTab,
      checkoutModalVisible,
      checkoutURI,
      setCheckoutModalVisibility,
      shortLinkModalVisible,
      shortLink,
      setShortLinkModalVisibility,
      summaryModalVisible,
      setSummaryModalVisibility,

      setConfigId,

      ringSKU,
      ringScreenshot,
      configID,
      assetURI,

      checkoutIssues,
      price,

      fingerSize,
      fingerSizeFormatOptions,
      onFingerSizeChange,
      fingerSizeFormat,
      fingerSizeOptions,
      onFingerSizeFormatChange,
      ringWidth,
      ringWidthOptions,
      onRingWidthChange,
      ringThickness,
      ringThicknessOptions,
      onRingThicknessChange,
      autoRatio,
      onAutoRatioChange,

      metalGroups,
      onMetalGroupChange,
      currentMenuMetalGroup,
      onMenuMetalGroupChange,
      limitedMaterials,

      stoneCut,
      stoneCount,
      stoneCountOptions,
      onStoneCountChange,
      stoneSize,
      stoneSizeOptions,
      onStoneSizeChange,
      stoneGroups,
      onStoneGroupChange,
      currentMenuStoneGroup,
      onMenuStoneGroupChange,

      engravingText,
      onEngravingTextChange,
      engravingFont,
      engravingFontOptions,
      onEngravingFontChange,
    } = this.props.menuProps;

    const { scrolling } = this.state;

    const mobile = isMobile();
    const lowHeight = isLowHeight();

    const tabs = [
      {
        title: "Dimensions",
        icon: "dimensions",
        content: (
          <Dimensions
            fingerSize={fingerSize}
            fingerSizeOptions={fingerSizeOptions}
            onFingerSizeChange={(value) => {
              onFingerSizeChange(value);
              //setConfigId();
            }}
            fingerSizeFormat={fingerSizeFormat}
            fingerSizeFormatOptions={fingerSizeFormatOptions}
            onFingerSizeFormatChange={(value) => {
              onFingerSizeFormatChange(value);
              //setConfigId();
            }}
            ringWidth={ringWidth}
            ringWidthOptions={ringWidthOptions}
            onRingWidthChange={(value) => {
              onRingWidthChange(value);
              //setConfigId();
            }}
            ringThickness={ringThickness}
            ringThicknessOptions={ringThicknessOptions}
            onRingThicknessChange={(value) => {
              onRingThicknessChange(value);
              //setConfigId();
            }}
            autoRatio={autoRatio}
            onAutoRatioChange={(value) => {
              onAutoRatioChange(value);
              //setConfigId();
            }}
            checkoutIssues={checkoutIssues}
            scrolling={scrolling}
          />
        ),
      },
      {
        title: "Materials",
        icon: "materials",
        content: (
          <Materials
            metalGroups={metalGroups}
            onMetalGroupChange={(value) => {
              onMetalGroupChange(value);
              //setConfigId();
            }}
            currentMenuMetalGroup={currentMenuMetalGroup}
            onCurrentMenuMetalGroupChange={(value) => {
              onMenuMetalGroupChange(value);
              //setConfigId();
            }}
            limitedMaterials={limitedMaterials}
            assetURI={assetURI}
          />
        ),
      },
      {
        title: "Stones",
        icon: "stones",
        content: (
          <Stones
            stoneCut={stoneCut}
            stoneCount={stoneCount}
            stoneCountOptions={stoneCountOptions}
            onStoneCountChange={(value) => {
              onStoneCountChange(value);
              //setConfigId();
            }}
            stoneSize={stoneSize}
            stoneSizeOptions={stoneSizeOptions}
            onStoneSizeChange={(value) => {
              onStoneSizeChange(value);
              //setConfigId();
            }}
            stoneGroups={stoneGroups}
            onStoneGroupChange={(value) => {
              onStoneGroupChange(value);
              //setConfigId();
            }}
            currentMenuStoneGroup={currentMenuStoneGroup}
            onCurrentMenuStoneGroupChange={(value) => {
              onMenuStoneGroupChange(value);
              //setConfigId();
            }}
            scrolling={scrolling}
            assetURI={assetURI}
          />
        ),
      },
      {
        title: "Engraving",
        icon: "engraving",
        content: (
          <Engraving
            engravingText={engravingText}
            onEngravingTextChange={(value) => {
              onEngravingTextChange(value);
              //setConfigId();
            }}
            engravingFont={engravingFont}
            engravingFontOptions={engravingFontOptions}
            onEngravingFontChange={(value) => {
              onEngravingFontChange(value);
              //setConfigId();
            }}
          />
        ),
      },
    ];

    return (
      <MenuWrapper>
        <FooterContainer
          isOpen={this.state.isOpen}
          isSimple={this.props.menuType == "simple"}
          isPlugin={this.props.isPlugin}
          menuSide={this.props.appConfig.style?.menuSide}
          menuColor={this.props.appConfig.style?.menuColor}
        >
          {mobile && this.props.menuType == "simple" && (
            <FooterOpenBtn
              onClick={() => {
                this.setState({ isOpen: !this.state.isOpen });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="118"
                height="118"
                viewBox="0 0 118 118"
                fill="none"
              >
                <path
                  d="M14.75 34.4167H29.5"
                  stroke="#163300"
                  stroke-width="8.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.75 83.5833H44.25"
                  stroke="#163300"
                  stroke-width="8.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M88.5 83.5833H103.25"
                  stroke="#163300"
                  stroke-width="8.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M73.75 34.4167H103.25"
                  stroke="#163300"
                  stroke-width="8.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M29.5 34.4167C29.5 29.8349 29.5 27.544 30.2485 25.7369C31.2465 23.3275 33.1609 21.4132 35.5703 20.4152C37.3774 19.6667 39.6683 19.6667 44.25 19.6667C48.8317 19.6667 51.1225 19.6667 52.9299 20.4152C55.339 21.4132 57.2536 23.3275 58.2517 25.7369C59 27.544 59 29.8349 59 34.4167C59 38.9984 59 41.2893 58.2517 43.0964C57.2536 45.5058 55.339 47.4201 52.9299 48.4182C51.1225 49.1667 48.8317 49.1667 44.25 49.1667C39.6683 49.1667 37.3774 49.1667 35.5703 48.4182C33.1609 47.4201 31.2465 45.5058 30.2485 43.0964C29.5 41.2893 29.5 38.9984 29.5 34.4167Z"
                  stroke="#163300"
                  stroke-width="8.5"
                />
                <path
                  d="M59 83.5833C59 79.0015 59 76.7108 59.7483 74.9035C60.7464 72.4943 62.661 70.5797 65.0701 69.5817C66.8775 68.8333 69.1682 68.8333 73.75 68.8333C78.3318 68.8333 80.6225 68.8333 82.4299 69.5817C84.839 70.5797 86.7536 72.4943 87.7517 74.9035C88.5 76.7108 88.5 79.0015 88.5 83.5833C88.5 88.1652 88.5 90.4559 87.7517 92.2632C86.7536 94.6724 84.839 96.5869 82.4299 97.585C80.6225 98.3333 78.3318 98.3333 73.75 98.3333C69.1682 98.3333 66.8775 98.3333 65.0701 97.585C62.661 96.5869 60.7464 94.6724 59.7483 92.2632C59 90.4559 59 88.1652 59 83.5833Z"
                  stroke="#163300"
                  stroke-width="8.5"
                />
              </svg>
              {/* {this.state.isOpen ? <DownOutlined /> : <UpOutlined />} */}
              Filters
            </FooterOpenBtn>
          )}
          <PriceWrapper isPlugin={this.props.isPlugin}>
            {this.props.menuProps.price != 0 && (
              <TotalPrice>
                ${this.props.menuProps.price.toLocaleString("en-US")}
              </TotalPrice>
            )}
            {mobile && (
              <FooterDetail>
                <FooterDetailText fontSize="14px">
                  Design: {ringSKU}
                </FooterDetailText>
                {this.props.hideRef ? (
                  ""
                ) : (
                  <FooterDetailText>Reference ID: {configID}</FooterDetailText>
                )}
              </FooterDetail>
            )}
            <ButtonWithBackground
              onClick={() => {
                this.props.menuProps.onCheckout();
              }}
              isPlugin={this.props.isPlugin}
            >
              <span className="text">{"Add to Cart"}</span>
              {this.props.isPlugin ? null : (
                <React.Fragment>
                  {!mobile && <ArrowRightOutlined />}
                  {mobile && <RightOutlined />}
                </React.Fragment>
              )}
            </ButtonWithBackground>
            {this.props.isSave ? (
              <ButtonWithBackground
                onClick={() => {
                  this.props.saveDesign();
                }}
                isPlugin={true}
              >
                <span className="text">{"Export design"}</span>
              </ButtonWithBackground>
            ) : (
              ""
            )}
            {this.props.isSave ? (
              <ButtonWithBackground
                onClick={() => {
                  this.props.downloadSS();
                }}
                isPlugin={true}
              >
                <span className="text">{"Screenshot"}</span>
              </ButtonWithBackground>
            ) : (
              ""
            )}
          </PriceWrapper>
          {this.props.isPlugin ? null : (
            <React.Fragment>
              {!mobile && (
                <FooterDetail>
                  <FooterDetailText fontSize="14px">
                    Design: {ringSKU}
                  </FooterDetailText>
                  {this.props.hideRef ? (
                    ""
                  ) : (
                    <FooterDetailText>
                      Reference ID: {configID}
                    </FooterDetailText>
                  )}
                </FooterDetail>
              )}
            </React.Fragment>
          )}
          {/* {checkoutIssues.includes('fingerSize') && (
            <NotifyWrapper>You need to select the finger size</NotifyWrapper>
          )} */}
          {this.state.isNoti && (
            <NotifyWrapper>You need to select the finger size</NotifyWrapper>
          )}
        </FooterContainer>
        <MenuContainer
          isOpen={this.state.isOpen}
          isSimple={this.props.menuType == "simple"}
          menuColor={this.props.appConfig.style?.menuColor}
        >
          {/* {currentMenuTab >= 0 && tabs[currentMenuTab].content} */}
          {tabs.map((tab, index) => (
            <div key={index}>{tab.content}</div>
          ))}
        </MenuContainer>
      </MenuWrapper>
    );
  }
}
